import React from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import HomeMainTitle from '../../../homeTitle/HomeMainTitle'

const CompanyInfo = ({data}) => {
    const {t} = useTranslation();

    return (
        <Container fluid className='py-4 mt-5' style={{background: '#eee'}}>
            <Container>
                <HomeMainTitle>{t("dashboard_nav_company_info")}</HomeMainTitle>
                {data.profile &&
                    <div className='company-page-info'>
                        <div className='company-info-item'>
                            <span>{t("CEO name")} : </span>
                            <p>{data.profile.manager_name ? data.profile.manager_name : '-'} </p>
                        </div>
                        <div className='company-info-item'>
                            <span>{t("CEO phone number")} : </span>
                            <p>{data.profile.manager_mobile ? data.profile.manager_mobile : "-"} </p>
                        </div>
                        <div className='company-info-item'>
                            <span>{t("email address")} :</span>
                            <p>{data.profile.email ? data.profile.email : '-'} </p>
                        </div>

                        <div className='company-info-item'>
                            <span>{t("Central office address")} :</span>
                            <p>{data.profile.address ? data.profile.address : '-'} </p>
                        </div>

                        <div className='company-info-item'>
                            <span>{t("Central office phone")} :</span>
                            <p>{data.profile.phone ? data.profile.phone : '-'} </p>
                        </div>
                        <div className='company-info-item'>
                            <span>{t("Location of the factory")} :</span>
                            <p>{data.profile.location ? data.profile.location : '-'} </p>
                        </div>
                        <div className='company-info-item'>
                            <span>{t("full address")} :</span>
                            <p>{data.profile.factory_address ? data.profile.factory_address : '-'} </p>
                        </div>
                    </div>
                }
            </Container>
        </Container>
    )
}

export default CompanyInfo
